import { type Shift } from '@libraries/typescript/api_client';

type ShiftCancellationSignals = Pick<Shift, 'status' | 'latest_stage'>;

/**
 * Whether a shift is cancelled and must not be targeted by new outreach.
 *
 * Two independent signals can carry the cancellation: `status` is the synced
 * EHR state, while `latest_stage` is Phoebe's own lifecycle stage, which can
 * record the cancellation before the next sync updates `status`. Either one
 * is treated as authoritative so the composer never builds an outreach
 * against a dead shift.
 *
 * The backend applies the same two signals (see `create_quick_callout`),
 * which in turn mirror `effective_shift_status_expression`. Note the one
 * asymmetry: the extension's resolve endpoints only carry `status`, so a
 * stage-only cancellation reaches the composer and is caught here rather
 * than upstream.
 */
export function isCancelledShift(shift: ShiftCancellationSignals): boolean {
    return shift.status === 'cancelled' || shift.latest_stage === 'cancelled';
}
